import Router from 'vue-router'
import views from '@/views'
import pages from '@/pages'
import store from '@/store'
import 'nprogress/nprogress.css' // progress bar style
import NProgress from 'nprogress' // progress bar
const whiteList = ['/login', '/register', '/findPassword', '/emptPage','/productTrial','/quotation','/immediateDelivery','/cooperativeConsultation']
NProgress.configure({ showSpinner: false })

/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject)
	}
	return originalPush.call(this, location).catch(err => err)
}
const loadRoutes = (rous, paths, children) => {
	if (rous !== null && 'path' in rous) {
		let ps = paths.flat().filter(p => p)

		if (ps[ps.length - 1] === rous.name) {
			ps.splice(ps.length - 1, 1)
		}
		if (!children) {
			let filePs = ps.join('/')

			if (rous.path) {
				rous.path = (filePs ? '/' : '') + filePs + (rous.path[0] === '/' ? '' : '/') + rous.path
			} else {
				rous.path = filePs
			}
		}
		// rous.name = ps.concat([rous.name]).join('.');

		if (rous.children) {
			rous.children.forEach(child => {
				loadRoutes(child, [paths, child.name], true)
			})
			return [rous]
		}
		return [rous]
	}

	if (rous.length) {
		return rous.map(r => {
			return loadRoutes(r, [paths])
		})
	} else {
		let arr = []
		for (let k in rous) {
			arr = arr.concat(loadRoutes(rous[k], [paths, k]))
		}
		return arr
	}
}
function getCurrentMenuId(list, name) {
	let id = null
	list.forEach(it => {
		if (id) {
			return
		}
		if (it.name === name) {
			id = it.id
		} else if (it.children && it.children.length) {
			id = getCurrentMenuId(it.children, name)
		}
	})
	return id
}
export function createRouter() {
	let routes = loadRoutes(views).flat()
	routes = routes.concat(pages)
	//  let router = routes.map(it => {
	//     return {
	//         ...it,
	//         path: '/consignor.html#' + it.path
	//     }
	//  })
	const router = new Router({
		mode: 'hash',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		}
	})

	// 路由权限控制
	router.beforeEach(async (to, from, next) => {
		// 每次更新header消息数字
		if (whiteList.indexOf(to.path) === -1) {
			let userinfo = await store.dispatch('SET_ACCOUNT')
		}
		// 
		const { meta, name } = to
		const { fromName, fullPath } = from
		// if(fullPath == '/' && to.path == '/login'){
		// 	let rAuth = localStorage.getItem('tokenId')
		// 	if(rAuth){
		// 		next('/publicPage/myFortune')
		// 	}
		// }
		if (to.meta && !to.meta.noTitle && to.path !== '/login') {
			let breadcrumb = [];
			if(to.query.breadcrumb){
				breadcrumb = JSON.parse(to.query.breadcrumb)
			}
			// 因为浏览器会把对象字符串化，故先转成字符串
			if(breadcrumb.length && breadcrumb[breadcrumb.length - 1].name !== to.name){
				to.query.breadcrumb = JSON.stringify(breadcrumb.concat({
					name: to.name,
					title: to.meta.title
				}))
			}
			if(breadcrumb.length === 0){
				to.query.breadcrumb = JSON.stringify(breadcrumb.concat({
					name: to.name,
					title: to.meta.title
				}))
			}
			
		}
		const hasNames = store.getters['log/primaryMenus']
		// 
		if (hasNames) {
			next()
		} else {
			if (whiteList.indexOf(to.path) !== -1) {
				next()
				NProgress.done()
			} else {
				try {
					//   await store.dispatch('user/getInfo')
          			let data1 = await store.dispatch('log/getMenuList')
					let data2 = await store.dispatch('log/selectUserPermissionList')
					let data3 = await store.dispatch('log/getCollectionList')
					next({ ...to, replace: true })
				} catch (error) {
					next(`/login`)
					NProgress.done()
				}
			}
		}
	})

	router.afterEach((to, from) => {
		let dom = document.getElementsByClassName('app-main')
		if (dom[0]) {
			dom[0].scrollTop = 0
		}

		// 每次跳转路由之后，将当前的路由存起来
		let currentMenus = store.getters['log/currentMenus']
		// 如果没有缓存的当前的路由，就取存在本地的路由
		if(!currentMenus){
			let localMenus = localStorage.getItem('currentMenus');
			if(localMenus){
				currentMenus = JSON.parse(localMenus);
				// currentMenus.breadcrumb
				store.dispatch('setCurrentMenu', currentMenus);
			}
		}
		if (!currentMenus || to.path !== currentMenus.path) {
			let menuList = store.getters['log/menuList']
			let currentMenusId = getCurrentMenuId(menuList, to.name)
			// 如果当前路由没有id，就取from的路由的id
			if (!currentMenusId && currentMenus) {
				currentMenusId = currentMenus.id
			}
			// currentMenusId = getCurrentMenuId(menuList, from.name)
			store.dispatch('setCurrentMenu', {
				name: to.name,
				path: to.path,
				query: to.query,
				meta: to.meta,
				id: currentMenusId
			})
		}
		NProgress.done()
	})

	return router
}
